
const digest = '2723d96e679a5e58f20446bcb3b3ee8d4712260a6edbe18ba718697da4f19c2c';
const classes = {"item":"_item_1llh5_1","patient":"_patient_1llh5_8","patientData":"_patientData_1llh5_16","text":"_text_1llh5_21","content":"_content_1llh5_25","extra":"_extra_1llh5_32","title":"_title_1llh5_36","name":"_name_1llh5_41","controls":"_controls_1llh5_52","link":"_link_1llh5_63"};
const css = `._item_1llh5_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._item_1llh5_1 ._patient_1llh5_8 {
  display: flex;
  border-right: 1px solid #eaedf3;
  padding: 24px;
  gap: 10px;
  min-width: 150px;
  max-width: 150px;
}
._item_1llh5_1 ._patient_1llh5_8 ._patientData_1llh5_16 {
  display: flex;
  gap: 12px;
  flex-direction: column;
}
._item_1llh5_1 ._patient_1llh5_8 ._patientData_1llh5_16 ._text_1llh5_21 {
  color: #3e3f42;
  font-size: 14px;
}
._item_1llh5_1 ._content_1llh5_25 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
}
._item_1llh5_1 ._content_1llh5_25 ._extra_1llh5_32 {
  display: flex;
  gap: 40px;
}
._item_1llh5_1 ._content_1llh5_25 ._title_1llh5_36 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
._item_1llh5_1 ._content_1llh5_25 ._name_1llh5_41 {
  font-size: 14px;
  color: #000000;
  display: flex;
  align-items: center;
  gap: 5px;
}
._item_1llh5_1 ._content_1llh5_25 ._name_1llh5_41 span {
  color: #9ea0a5;
  font-weight: 400;
}
._item_1llh5_1 ._controls_1llh5_52 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 12px;
}
._item_1llh5_1 ._controls_1llh5_52 ._link_1llh5_63 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  